import { render, staticRenderFns } from "./SponsorBox.vue?vue&type=template&id=07cd08d6&"
import script from "./SponsorBox.vue?vue&type=script&lang=js&"
export * from "./SponsorBox.vue?vue&type=script&lang=js&"
import style0 from "./SponsorBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports